import UserProfile from "../Models/UserProfile";
import notify from "devextreme/ui/notify";
import { InterfaceChangePassword } from "../Models/Project/InterfaceChangePassword";
import axios, { isAxiosError } from "axios";
import { ResultsSet } from "../Models/Project/ValidationError";
import {
  IMessageParamsGETFSOBJECTS,
  IMessageParamsGETFTPOBJECTS,
  IMessageParamsPRINTFSOBJECTS,
  IMessageParamsSQLQUERY,
} from "../Models/Project/EDI ECube/MessageParams";
import { RoutePath } from "../Utils/RoutePath";
import { ResourceView } from "../Models/SysConf/ResourceView";
import ResourceField from "../Models/ResourceField";
import { DataExchangeJobsTranscode } from "../Models/Resources/DataExchangeJobsTranscode";
import { API_URL } from "../Costant";
import { FilterList } from "../Models/Project/FilterList";
import { ResourceNames } from "../Utils/ResourceNames";
import ResourcesLookups from "../Models/ResourcesLookups";
import { MenuItemGridCustomAction } from "../Models/SysConf/MenuItemGridCustomAction";
import { ResourceAttachment } from "../Models/SysConf/ResourceAttachment";
import { UserCompany } from "../Models/SysConf/UserCompany";
import { UserProduct } from "../Models/Project/UserProduct";
import { WebSocketClient } from "../Models/SysConf/WebSocketClient";
import { LoginResponse } from "../Models/Project/LoginResponse";
import { ResourceViewFieldFiltered } from "../Models/SysConf/ResourceViewFieldFiltered";
import { DataExchangeJobLogs } from "../Models/Resources/DataExchangeJobLogs";
import { DataExchangeJobDevice } from "../Models/Resources/DataExchangeJobDevice";
import { DataExchangeDevice } from "../Models/Resources/DataExchangeDevice";
import { ResourceViewField } from "../Models/SysConf/ResourceViewField";
import { DataExchangePlugin } from "../Models/Resources/DataExchangePlugin";
import { DataExchangeJobPlugin } from "../Models/Resources/DataExchangeJobPlugin";
import { ProdCalendarioDipendente } from "../Models/Resources/ProdCalendarioDipendente";
import { ProdVersamentoTempiGiornaliero } from "../Models/Resources/ProdVersamentoTempiGiornaliero";
import { Dipendente } from "../Models/Resources/Dipendente";
import { VersamentoSpese } from "../Models/Resources/ProdVersamentoSpese";
import { Form } from "../Models/SysConf/Form";
import { ResourceViewSortField } from "../Models/SysConf/ResourceViewSortField";
import { ProdSpesa } from "../Models/Resources/ProdSpesa";
import { ProdVersamentoTempo } from "../Models/Resources/ProdVersamentoTempo";
import { FormField } from "../Models/SysConf/FormField";
import { ProdSessioneLavoroBm } from "../Models/Resources/ProdSessioneLavoroBm";
import { ProdParamVersamentoTempiSpese } from "../Models/Resources/ProdParamVersamentoTempiSpese";
import { DataExchangeJob } from "Models/Resources/DataExchangeJob";

export interface CommonCubeResponse {
  MessageResult: string;
  Result: number;
}

export interface ResultsSetCubeSuccessResponse {
  NumberOfPages: number;
  TotalRowCount: number;
  objectList: any[] | null;
}

export interface CubeSuccessResponse {
  Resource_ID: number;
  ResourcesViewsFields: Array<ResourceViewField>;
  ResourcesViewsSortFields: Array<ResourceViewSortField>;
  Results: ResultsSetCubeSuccessResponse;
}

export default class cubeApiClient {
  getProdCausaliSospMES = async (tokenApi: string): Promise<any> => {
    try {
      const response = await axios.get(`${this.apiUrl}api/ProdCausaliSospMES`, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
          Accept: "application/json",
        },
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  };

  apiUrl: string =
    process.env.NODE_ENV === "development"
      ? API_URL
      : window.location.origin === "http://localhost:3000"
      ? API_URL
      : window.location.origin + "/";
  // pushClientUrl: string = PUSHCLIENT_URL;

  /* USER FUNCTIONS */
  login = async (
    username: string,
    password: string,
    rememberMe: boolean
  ): Promise<LoginResponse> => {
    try {
      const response = await axios.post(
        `${this.apiUrl}Token?rememberMe=${rememberMe ? "1" : "0"}`,
        {
          grant_type: "password",
          username: username,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  };

  loginAuthToken = async (authToken: string): Promise<LoginResponse> => {
    try {
      const response = await axios.post(`${this.apiUrl}api/Account/Login`, {
        Token: authToken,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  };

  impersonate = async (
    authToken: string,
    externalId: string
  ): Promise<LoginResponse> => {
    try {
      const response = await axios.post(
        `${this.apiUrl}api/Account/Impersonate`,
        {
          RememberToken: authToken,
          ExternalId: externalId,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  };

  forgotPassword = async (emailOrUsername: string) => {
    try {
      let url = `${this.apiUrl}api/account/ForgotPassword`;

      let object = {
        baseUrl: window.location.href.replace(RoutePath.FORGOT_PASSWORD, ""),
        User: emailOrUsername,
      };

      await axios.post(url, object);
    } catch (err) {
      throw err;
    }
  };

  checkResetPasswordToken = async (
    token: string
  ): Promise<{
    MessageResult: string;
    Result: number;
  }> => {
    try {
      let url = `${this.apiUrl}api/account/CheckResetPasswordToken`;

      let object = {
        Token: token,
      };

      const response = await axios.post(url, object);

      return response.data;
    } catch (err) {
      throw err;
    }
  };

  resetPassword = async (
    token: string,
    password: string,
    confirmPassword: string
  ): Promise<{
    MessageResult: string;
    Result: number;
  }> => {
    try {
      let url = `${this.apiUrl}api/account/TokenResetPassword`;

      let object = {
        Token: token,
        NewPassword: password,
        ConfirmPassword: confirmPassword,
      };

      const response = await axios.post(url, object);

      return response.data;
    } catch (err) {
      throw err;
    }
  };

  changePassword = async (
    newPassObj: InterfaceChangePassword,
    tokenAPI: string
  ) => {
    const config = {
      method: "POST",
      headers: {
        Authorization: "bearer " + tokenAPI,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newPassObj),
    };

    const response = await fetch(
      this.apiUrl + "api/account/ChangePassword",
      config
    );

    const data = await response.json();

    if (response.ok) return true;
    else {
      const errorData = "Password sbagliata";
      throw errorData;
    }
  };

  changeUserProfile = async (profile: UserProfile, tokenAPI: string) => {
    const arrayUP = [
      new UserProfile(
        profile.customer_ID,
        profile.UserId,
        profile.AgenteID,
        profile.UserName,
        profile.CompanyName,
        profile.CompanyAddress,
        profile.ERPCompanyCode,
        profile.ProtectionLevel,
        profile.ProductCode,
        profile.Roles,
        profile.FirstName,
        profile.LastName,
        profile.NickName,
        profile.LocateString,
        profile.cod_dipendente,
        profile.cod_operatore
      ),
    ];

    const config = {
      method: "POST",
      headers: {
        Authorization: "bearer " + tokenAPI,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(arrayUP),
    };

    try {
      const response = await fetch(this.apiUrl + "api/sys/UserProfile", config);

      const data = await response.json();

      return data;
    } catch (err) {
      alert("changeUserProfile" + err);
      return [{ id: 999, title: "ERROREACCIO" }];
    }
  };

  getSettings = async (
    tokenAPI: string
  ): Promise<{
    Id: number;
    PushServiceUrl: string;
    WSSUrl: string;
  }> => {
    let url = `${this.apiUrl}api/sys/Settings`;

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      if (data && data.length > 0) return data[0];
      else {
        throw "Errore nel caricamento delle impostazioni";
      }
    } catch (err) {
      throw err;
    }
  };

  loginGeaf = async (userName: string, tokenAPI: string): Promise<any> => {
    try {
      let url = `${this.apiUrl}api/Resources/GeafLoginCF?CF=${userName}`;

      const { data } = await axios.get(url, {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (err) {
      throw err;
    }
  };

  async getProdLookupDipendenti(tokenAPI: string): Promise<Dipendente[]> {
    try {
      let url = `${this.apiUrl}api/Resources/ProdLookupDipendenti/query`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      }

      return [];
    } catch (err) {
      throw err;
    }
  }

  async getAll(resourceURL: string, tokenAPI: string, isReport?: boolean) {
    const UrlToUse = this.apiUrl + resourceURL;

    try {
      const response = await fetch(UrlToUse, {
        method: "GET",
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      try {
        const data = await response.json();

        if (response.ok) {
          return data;
        }

        // Se response non è ok mando un alert con cosa è andato storto
        else {
          if (isReport && isReport === true) return data[0].MessageResult;
          throw data[0].MessageResult;
        }
      } catch (errResponseJSON) {
        if (!response.ok) {
          //alert('Errore nel JSON Response alla chiamata: ' + resourceURL + '. ' + errResponseJSON)
          throw errResponseJSON;
        }
      }
    } catch (errFetch) {
      if (errFetch && String(errFetch) > "") notify(errFetch, "error", 2000);
      else {
        notify(
          "Errore nel fetch alla chiamata: " + resourceURL + ". " + errFetch,
          "error",
          2000
        );
      }
      throw errFetch;
    }
  }

  //http://dev.e-cube.it/api/Resources/ProdVersamentoTempiGiornalieri?fcod_dipendente=15
  getProdVersamentoTempiGiornalieri = async (
    codDipendente: string,
    fromDate: string,
    toDate: string,
    tokenAPI: string
  ): Promise<ProdVersamentoTempiGiornaliero[]> => {
    let url = `${this.apiUrl}api/Resources/ProdVersamentoTempiGiornalieri/query`;

    let body = [
      {
        ResourcesViewsFilters: [
          {
            FieldName: "cod_dipendente",
            Operator: "equal",
            Value: codDipendente,
          },
          {
            FieldName: "dat_versamento",
            Operator: "greatequal",
            Value: fromDate,
          },
          {
            FieldName: "dat_versamento",
            Operator: "lessequal",
            Value: toDate,
            PreviousFilterOperator: "AND",
          },
        ],
      },
    ];

    try {
      const { data } = await axios.post(url, body, {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      }

      return [];
    } catch (err) {
      throw err;
    }
  };

  getProdVersamentoSpese = async (
    codDipendente: string,
    fromDate: string,
    toDate: string,
    tokenAPI: string,
    onlyExpenses: boolean
  ): Promise<VersamentoSpese[]> => {
    let url = `${this.apiUrl}api/Resources/ProdVersamentoSpese/query`;

    let body = [
      {
        ResourcesViewsFilters: [
          {
            FieldName: "cod_dipendente",
            Operator: "equal",
            Value: codDipendente,
          },
          {
            FieldName: "dat_spesa",
            Operator: "greatequal",
            Value: fromDate.concat("T00:00:00.000"),
          },
          {
            FieldName: "dat_spesa",
            Operator: "lessequal",
            Value: toDate.concat("T23:59:59.999"),
            PreviousFilterOperator: "AND",
          },
          !onlyExpenses
            ? {
                FieldName: "id_versamento",
                Operator: "isnull",
                Value: "",
                PreviousFilterOperator: "AND",
              }
            : undefined,
        ],
      },
    ];

    try {
      const { data } = await axios.post(url, body, {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      }

      return [];
    } catch (err) {
      throw err;
    }
  };

  getVersamentoTempiByBarcode = async (
    tokenAPI: string,
    objectToPass: Partial<ProdVersamentoTempo>
  ): Promise<ProdVersamentoTempo[]> => {
    let url = `${this.apiUrl}api/Resources/ProdVersamentoTempiUtils/query?op=unpackbarcode`;

    let body = [
      {
        CustomDataObject: objectToPass,
      },
    ];
    try {
      const { data } = await axios.post(url, body, {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      if (
        data &&
        data.length > 0 &&
        data[0].Results &&
        data[0].Results.objectList
      ) {
        return data[0].Results.objectList[0];
      } else {
        throw new Error("No data found");
      }
    } catch (error) {
      throw error;
    }
  };

  getEWCEntitiesStats = async (tokenApi: string): Promise<any[]> => {
    const url = `${this.apiUrl}api/Resources/EWCEntitiesStats`;

    try {
      const config = {
        method: "GET",
        headers: {
          Authorization: "bearer " + tokenApi,
          Accept: "application/json",
        },
      };

      const response = await fetch(url, config);

      if (!response.ok) {
        throw new Error("Failed to fetch EWC Entities Stats");
      }

      const data: any[] = await response.json();
      return data;
    } catch (err) {
      throw err;
    }
  };

  getProdSessioniLavoro = async (
    codDipendente: string,
    tokenApi: string
  ): Promise<ProdSessioneLavoroBm[]> => {
    let url = `${this.apiUrl}api/Resources/ProdSessioniLavoro/query?RecordSelection=cod_dipendente='${codDipendente}' AND (des_stato='Inserita' OR 
    des_stato='In esecuzione' OR des_stato='In pausa') `;

    try {
      const { data } = await axios.post(url, [], {
        headers: {
          Authorization: "bearer " + tokenApi,
          "Content-Type": "application/json",
        },
      });

      if (data && data.length && data[0].Results) {
        return data[0].Results.objectList;
      } else {
        return [];
      }
    } catch (error) {
      throw error;
    }
  };

  setProdSessioneState = async (
    tokenApi: string,
    sessionToPass: ProdSessioneLavoroBm[],
    keyWord: string,
    causale?: any
  ): Promise<any> => {
    let url: string;

    if (keyWord == "pause") {
      url = `${this.apiUrl}api/Resources/ProdSessioniLavoro?oper=${keyWord}&cod_causosp=${causale}`;
    } else {
      url = `${this.apiUrl}api/Resources/ProdSessioniLavoro?oper=${keyWord}`;
    }
    let body = sessionToPass;
    try {
      const { data } = await axios.post(url, body, {
        headers: {
          Authorization: "bearer " + tokenApi,
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (error) {
      throw error;
    }
  };

  duplicateProdSessioniLavoro = async (
    tokenApi: string,
    sessionToDuplicate: ProdSessioneLavoroBm
  ): Promise<any> => {
    let url = `${this.apiUrl}api/Resources/ProdSessioniLavoro?oper=duplicate`;

    let body = [sessionToDuplicate];

    try {
      const { data } = await axios.post(url, body, {
        headers: {
          Authorization: "bearer " + tokenApi,
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (error) {
      throw error;
    }
  };

  getProdVersamentoSpeseByIdVersamento = async (
    idVersamento: string, // uuid
    tokenApi: string
  ): Promise<VersamentoSpese[]> => {
    let url = `${this.apiUrl}api/Resources/ProdVersamentoSpese/query`;

    let body = [
      {
        ResourcesViewsFilters: [
          {
            FieldName: "id_versamento",
            Operator: "equal",
            Value: `${idVersamento}`,
          },
        ],
      },
    ];

    try {
      const { data } = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (
        data &&
        data.length > 0 &&
        data[0].Results &&
        data[0].Results.objectList
      ) {
        return data[0].Results.objectList;
      } else {
        return [];
      }
    } catch (error) {
      throw error;
    }
  };

  getProdVersamentoTempi = async (
    idVersamento: string,
    tokenApi: string,
    Id: number
  ): Promise<ProdVersamentoTempo[] | undefined> => {
    let url = `${this.apiUrl}api/Resources/ProdVersamentoTempi?RecordSelection=Id='${Id}'`;

    const params = {
      ResourcesViewsFilters: [
        {
          FieldName: "id_versamento",
          Operator: "equal",
          Value: idVersamento,
        },
      ],
    };

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (data && data.length) {
        return data[0];
      } else {
        return [];
      }
    } catch (error) {
      throw error;
    }
  };

  getProdVersamentoTempoByIdVersamento = async (
    idVersamento: string,
    tokenApi: string
  ): Promise<ProdVersamentoTempo> => {
    let url = `${this.apiUrl}api/Resources/ProdVersamentoTempi?RecordSelection=id_versamento='${idVersamento}'`;

    const params = {
      ResourcesViewsFilters: [
        {
          FieldName: "id_versamento",
          Operator: "equal",
          Value: idVersamento,
        },
      ],
    };

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (data && data.length) {
        return data[0];
      } else {
        throw new Error("No data found");
      }

      throw new Error("No data found");
    } catch (error) {
      throw error;
    }
  };

  getProdSpese = async (tokenApi: string): Promise<ProdSpesa[]> => {
    let url = `${this.apiUrl}api/Resources/ProdSpese/query`;

    try {
      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenApi,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  getProdCalendarioDipendente = async (
    codDipendente: string,
    fromDate: string,
    toDate: string,
    tokenAPI: string
  ): Promise<ProdCalendarioDipendente[]> => {
    let url = `${this.apiUrl}api/Resources/ProdCalendarioDipendente?cod_dipendente=${codDipendente}&fromdate=${fromDate}&todate=${toDate}`;

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (err) {
      throw err;
    }
  };

  // TODO - Verificare che la chiamata sia corretta
  getProdParamVersamentoTempiSpese = async (
    tokenApi: string
  ): Promise<ProdParamVersamentoTempiSpese> => {
    let url = `${this.apiUrl}api/Resources/ProdParamVersamentoTempiSpese`;

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: "bearer " + tokenApi,
          "Content-Type": "application/json",
        },
      });

      // qui ritorno solo il primo elemento, perché ho solo un elemento.
      if (data && Array.isArray(data) && data.length === 1) return data[0];
      else
        throw new Error(
          "Errore nel recupero dei parametri (getProdParamVersamentoTempiSpese)"
        );
    } catch (err) {
      throw err;
    }
  };

  getResources = async (tokenAPI: string): Promise<any[]> => {
    try {
      let url = `${this.apiUrl}api/sys/Resources/query`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      }

      return [];
    } catch (err) {
      throw err;
    }
  };

  getResourceViewsByResourceName = async (
    resourceName: string,
    tokenAPI: string
  ): Promise<ResourceView[]> => {
    try {
      let url = `${this.apiUrl}api/sys/ResourcesViewes/query?RecordSelection=ResourceName='${resourceName}'`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  getResourceViewByViewId = async (
    tokenAPI: string,
    viewId: number
  ): Promise<ResourceView | undefined> => {
    try {
      let url = `${this.apiUrl}api/sys/ResourcesViewes/query?RecordSelection=View_ID=${viewId}`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (
          data[0].Results.objectList &&
          data[0].Results.objectList.length > 0
        ) {
          return data[0].Results.objectList[0];
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    } catch (err) {
      throw err;
    }
  };

  getResourceViewsFieldsByViewName = async (
    tokenAPI: string,
    viewName: string
  ): Promise<ResourceViewField[]> => {
    try {
      let url = `${this.apiUrl}api/sys/ResourcesViewsFieldsLookup/query?RecordSelection=ViewName='${viewName}'`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  getResourceFieldsByResourceId = async (
    Resource_ID: number,
    tokenAPI: string
  ): Promise<ResourceField[]> => {
    try {
      let url = `${this.apiUrl}api/sys/ResourcesFields/query?RecordSelection=Resource_ID=${Resource_ID}`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  getResourceFieldsByResourceName = async (
    ResourceName: string | null,
    tokenAPI: string
  ): Promise<ResourceField[]> => {
    try {
      let url = `${this.apiUrl}api/sys/ResourcesFields/query?RecordSelection=ResourceName='${ResourceName}'`;

      const { data } = await axios.post(
        url,

        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,

            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  getDataExchangeJobByIdJob = async (
    idJob: string,
    tokenAPI: string
  ): Promise<DataExchangeJob> => {
    const url = `${this.apiUrl}api/dataexchange/job?job_id=${idJob}`;

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (err) {
      throw err;
    }
  };

  getDataExchangeDevicesByIdJob = async (
    idJob: string,
    tokenAPI: string
  ): Promise<{
    data: {
      deviceSource: DataExchangeDevice | undefined;
      deviceTarget: DataExchangeDevice | undefined;
    };
    id_job: string;
    des_params: string;
  }> => {
    try {
      let url = `${this.apiUrl}api/Resources/DataExchangeJobsDevices/query?RecordSelection=id_job='${idJob}'`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenAPI,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          let source: DataExchangeJobDevice | undefined =
            data[0].Results.objectList.find(
              (x: DataExchangeJobDevice) => x.flg_source
            );
          let target: DataExchangeJobDevice | undefined =
            data[0].Results.objectList.find(
              (x: DataExchangeJobDevice) => x.flg_target
            );

          let deviceSource: DataExchangeDevice | undefined = undefined;
          let deviceTarget: DataExchangeDevice | undefined = undefined;
          let des_params: string = "{}";

          if (source) {
            des_params = source.des_params;

            // Recupero il device source
            let urlDeviceSource = `${this.apiUrl}api/Resources/DataExchangeDevices/query?RecordSelection=id_device='${source.id_device}'`;

            const { data: dataDeviceSource } = await axios.post(
              urlDeviceSource,
              {},
              {
                headers: {
                  Authorization: "bearer " + tokenAPI,
                  "Content-Type": "application/json",
                },
              }
            );

            if (
              dataDeviceSource &&
              dataDeviceSource.length > 0 &&
              dataDeviceSource[0].Results
            ) {
              if (dataDeviceSource[0].Results.objectList) {
                deviceSource = dataDeviceSource[0].Results.objectList[0];
              }
            }
          }

          if (target) {
            // Recupero il device target
            let urlDeviceTarget = `${this.apiUrl}api/Resources/DataExchangeDevices/query?RecordSelection=id_device='${target.id_device}'`;

            const { data: dataDeviceTarget } = await axios.post(
              urlDeviceTarget,
              {},
              {
                headers: {
                  Authorization: "bearer " + tokenAPI,
                  "Content-Type": "application/json",
                },
              }
            );

            if (
              dataDeviceTarget &&
              dataDeviceTarget.length > 0 &&
              dataDeviceTarget[0].Results
            ) {
              if (dataDeviceTarget[0].Results.objectList) {
                deviceTarget = dataDeviceTarget[0].Results.objectList[0];
              }
            }
          }

          return {
            data: {
              deviceSource: deviceSource,
              deviceTarget: deviceTarget,
            },
            id_job: idJob,
            des_params: des_params,
          };
        } else {
          throw new Error("Errore nel fetch della vista");
        }
      }

      throw new Error("Errore nel fetch della vista");
    } catch (err) {
      throw err;
    }
  };

  getDataExchangePluginsByIdJob = async (
    idJob: string,
    tokenAPI: string,
    jobsPlungins?: DataExchangeJobPlugin[]
  ): Promise<{
    data: {
      pluginSource: DataExchangePlugin | undefined;
      pluginTarget: DataExchangePlugin | undefined;
    };
    id_job: string;
  }> => {
    let jp: DataExchangeJobPlugin[] = [];
    if (jobsPlungins && jobsPlungins.length > 0) {
      jp = jobsPlungins;
    } else {
      let url = `${this.apiUrl}api/Resources/DataExchangeJobsPlugins/query?RecordSelection=id_job='${idJob}'`;

      try {
        const { data } = await axios.post(
          url,
          {},
          {
            headers: {
              Authorization: "bearer " + tokenAPI,
              "Content-Type": "application/json",
            },
          }
        );

        if (data && data.length > 0 && data[0].Results) {
          if (data[0].Results.objectList) {
            jp = data[0].Results.objectList;
          }
        }
      } catch (err) {
        throw err;
      }
    }

    if (jp && jp.length > 0) {
      let source = jp.find((x: DataExchangeJobPlugin) => x.flg_source);
      let target = jp.find((x: DataExchangeJobPlugin) => x.flg_target);

      let pluginSource: DataExchangePlugin | undefined = undefined;
      let pluginTarget: DataExchangePlugin | undefined = undefined;

      if (source) {
        // Recupero il plugin source
        let urlPluginSource = `${this.apiUrl}api/Resources/DataExchangePlugins/query?RecordSelection=id_plugin='${source.id_plugin}'`;

        try {
          const { data: dataPluginSource } = await axios.post(
            urlPluginSource,
            {},
            {
              headers: {
                Authorization: "bearer " + tokenAPI,
                "Content-Type": "application/json",
              },
            }
          );

          if (
            dataPluginSource &&
            dataPluginSource.length > 0 &&
            dataPluginSource[0].Results
          ) {
            if (dataPluginSource[0].Results.objectList) {
              pluginSource = dataPluginSource[0].Results.objectList[0];
            }
          }
        } catch (err) {
          throw err;
        }
      }

      if (target) {
        // Recupero il plugin target
        let urlPluginTarget = `${this.apiUrl}api/Resources/DataExchangePlugins/query?RecordSelection=id_plugin='${target.id_plugin}'`;

        try {
          const { data: dataPluginTarget } = await axios.post(
            urlPluginTarget,
            {},
            {
              headers: {
                Authorization: "bearer " + tokenAPI,
                "Content-Type": "application/json",
              },
            }
          );

          if (
            dataPluginTarget &&
            dataPluginTarget.length > 0 &&
            dataPluginTarget[0].Results
          ) {
            if (dataPluginTarget[0].Results.objectList) {
              pluginTarget = dataPluginTarget[0].Results.objectList[0];
            }
          }
        } catch (err) {
          throw err;
        }
      }

      return {
        data: {
          pluginSource: pluginSource,
          pluginTarget: pluginTarget,
        },
        id_job: idJob,
      };
    } else {
      throw new Error("Errore nel fetch della vista");
    }
  };

  getDataExchangeJobTranscodeByIdJob = async (
    idJob: string,

    tokenAPI: string
  ): Promise<DataExchangeJobsTranscode[]> => {
    try {
      let url = `${this.apiUrl}api/Resources/DataExchangeJobsTranscodes/query?RecordSelection=id_job='${idJob}'`;

      const { data } = await axios.post(
        url,

        {},

        {
          headers: {
            Authorization: "bearer " + tokenAPI,

            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data && data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  duplicateResourceView = async (
    resourceViewToDuplicate: ResourceView,
    tokenAPI: string
  ): Promise<ResourceView> => {
    try {
      let url = `${this.apiUrl}api/sys/ResourcesViewsClone`;

      const { data } = await axios.post(url, [resourceViewToDuplicate], {
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
      });

      if (data && data.length > 0) {
        return data[0];
      } else {
        throw new Error("Errore nel duplicare la vista");
      }
    } catch (err) {
      throw err;
    }
  };

  getResourcesLookupsByLookupName = async (
    tokenApi: string,
    name: string
  ): Promise<ResourcesLookups | undefined> => {
    try {
      let url = `${this.apiUrl}api/sys/${ResourceNames.ResourcesLookups}/query?RecordSelection=LookupName='${name}'`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenApi,
            "Content-Type": "application/json",
          },
        }
      );
      if (data && data.length > 0 && data[0].Results) {
        if (
          data[0].Results.objectList &&
          data[0].Results.objectList.length > 0
        ) {
          return data[0].Results.objectList[0];
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    } catch (err) {
      throw err;
    }
  };

  getResourcesFiltersByJobId = async (
    jobId: string,
    tokenApi: string
  ): Promise<ResourceViewFieldFiltered[]> => {
    try {
      let url = `${this.apiUrl}api/Resources/DataExchangeJobsPreviewColumns/query?RecordSelection=id_job='${jobId}'`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenApi,
            "Content-Type": "application/json",
          },
        }
      );
      if (data && data.length > 0 && data[0].Results) {
        if (
          data[0].Results.objectList &&
          data[0].Results.objectList.length > 0
        ) {
          return data[0].Results.objectList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  getFormByResourceName = async (
    resourceName: string,
    tokenApi: string
  ): Promise<Form> => {
    // Recupero il ResourceId dal nome della risorsa
    let urlResourceId = `${this.apiUrl}api/sys/Resources/query?RecordSelection=ResourceName='${resourceName}'`;

    try {
      const { data: dataResourceId } = await axios.post(
        urlResourceId,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenApi,
          },
        }
      );

      if (
        dataResourceId &&
        dataResourceId.length > 0 &&
        dataResourceId[0].Results
      ) {
        if (
          dataResourceId[0].Results.objectList &&
          dataResourceId[0].Results.objectList.length > 0
        ) {
          let resource = dataResourceId[0].Results.objectList[0];
          if (!resource) throw new Error("Resource non trovata");

          let urlForm = `${this.apiUrl}api/sys/${ResourceNames.Forms}/query?ResourceId=${resource.Resource_ID}`;

          const { data: dataForm } = await axios.post(
            urlForm,
            {},
            {
              headers: {
                Authorization: "bearer " + tokenApi,
              },
            }
          );

          if (dataForm && dataForm.length > 0 && dataForm[0].Results) {
            if (
              dataForm[0].Results.objectList &&
              dataForm[0].Results.objectList.length > 0
            ) {
              return dataForm[0].Results.objectList[0];
            } else {
              throw new Error("Form non trovata");
            }
          } else {
            throw new Error("Errore nel fetch della vista");
          }
        } else {
          throw new Error("Errore nel fetch della vista");
        }
      } else {
        throw new Error("Errore nel fetch della vista");
      }
    } catch (err) {
      throw err;
    }
  };

  getFormByFormId = async (formId: number, tokenApi: string): Promise<Form> => {
    let urlForm = `${this.apiUrl}api/sys/${ResourceNames.Forms}/query?FormID=${formId}`;

    try {
      const { data: dataForm } = await axios.post(
        urlForm,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenApi,
          },
        }
      );

      if (dataForm && dataForm.length > 0 && dataForm[0].Results) {
        if (
          dataForm[0].Results.objectList &&
          dataForm[0].Results.objectList.length > 0
        ) {
          return dataForm[0].Results.objectList[0];
        } else {
          throw new Error("Form non trovata");
        }
      } else {
        throw new Error("Errore nel fetch della vista");
      }
    } catch (err) {
      throw err;
    }
  };

  getAllFormFields = async (
    tokenApi: string,
    jumpmenu_id?: number | null,
    MenuItemID?: number | null,
    ResourceId?: number
  ): Promise<FormField[]> => {
    try {
      if (!jumpmenu_id && !MenuItemID && !ResourceId)
        throw new Error("Errore nel fetch dei form fields");

      let url = `${this.apiUrl}api/sys/${ResourceNames.FormFieldsList}/query?`;
      if (jumpmenu_id) url += `jumpmenu_id=${jumpmenu_id}`;
      else if (MenuItemID) url += `MenuItemID=${MenuItemID}`;
      else if (ResourceId) url += `ResourceId=${ResourceId}`;

      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "bearer " + tokenApi,
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        if (data[0].Results.objectList) {
          return data[0].Results.objectList;
        } else {
          throw new Error("Form fields non trovati");
        }
      } else {
        throw new Error("Errore nel fetch dei form fields");
      }
    } catch (err) {
      throw err;
    }
  };

  // LOCKS
  async getLock(
    recourceId: number | string,
    itemId: number | string,
    tokenApi: string,
    sessionId: string,
    pushClientUrl: string
  ): Promise<boolean> {
    try {
      // Rimuovo l'ultimo carattere se è un slash
      let url = `${pushClientUrl}record/lock?Resource_ID=${recourceId}&Item_ID=${itemId}&Session_ID=${sessionId}`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      // data.Result = 0 -> lock riuscito
      // data.Result = 1 -> lock già esistente
      // data.Result = 99 -> errore generico

      if (data.Result === 0) return true;
      else if (data.Result === 1) throw new Error(data.ResultMessage);
      else if (data.Result === 99) throw new Error(data.ResultMessage);
      else throw new Error("Qualcosa è andato storto");

      return false;
    } catch (errFetch) {
      throw errFetch;
    }
  }

  async releaseLock(
    recourceId: number | string,
    itemId: number | string,
    tokenApi: string,
    sessionId: string,
    pushClientUrl: string
  ): Promise<boolean> {
    try {
      let url = `${pushClientUrl}record/release?Resource_ID=${recourceId}&Item_ID=${itemId}&Session_ID=${sessionId}`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (data.Result === 0) return true;
      else if (data.Result === 1) throw new Error(data.ResultMessage);
      else if (data.Result === 99) throw new Error(data.ResultMessage);
      else throw new Error("Qualcosa è andato storto");

      return false;
    } catch (err) {
      throw err;
    }
  }

  async releaseAllLocks(
    tokenApi: string,
    sessionId: string,
    pushClientUrl: string
  ) {
    try {
      let url = `${pushClientUrl}record/unlock/all?Session_ID=${sessionId}&token=${tokenApi}`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (data.Result !== 0)
        throw new Error("Errore nella release di tutti i lock");

      return data;
    } catch (err) {
      throw err;
    }
  }

  // EDI
  async ecubeEdiCommand(
    command: string,
    messageParams:
      | IMessageParamsGETFSOBJECTS
      | IMessageParamsPRINTFSOBJECTS
      | IMessageParamsGETFTPOBJECTS
      | IMessageParamsSQLQUERY,
    tokenApi: string,
    pushClientUrl: string
  ): Promise<any> {
    try {
      let url = `${pushClientUrl}command`;

      let bodyObject = {
        CommandName: command,
        MessageType: 2,
        MessageParams: messageParams,
      };

      const { data } = await axios.post(url, bodyObject, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (data.Result !== 0) throw new Error(data.ResultMessage);
      else {
        if (data.ResultObject && data.ResultObject.MessageParams) {
          return data.ResultObject.MessageParams;
        }
      }

      return data;
    } catch (err) {
      throw err;
    }
  }

  async ecubeEdiGetColumns(
    tokenApi: string,
    pluginObject: {
      Params: string; // Dipende dal sorgente dati
      Input: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Content: string[]; // Base64
    }
  ): Promise<string> {
    let url = `${this.apiUrl}api/DataExchange/Columns`;
    try {
      const response = await axios.post(url, pluginObject, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (response.status !== 200) throw new Error("Errore nella richiesta");
      else {
        if (response.data && response.data.Columns)
          return response.data.Columns;
        else if (response.data && response.data.Columns === null) return "";
        else throw new Error("Errore nella richiesta");
      }
    } catch (err) {
      throw err;
    }
  }

  async ecubeEdiOutput(
    tokenApi: string,
    pluginObject: {
      Params: string; // Dipende dal sorgente dati
      Input: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Output: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Content: string; // Base64
    }
  ): Promise<{
    Result: number;
    MessageResult: string;
  }> {
    let url = `${this.apiUrl}api/DataExchange`;
    try {
      const response = await axios.post(url, pluginObject, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (response.status !== 200) throw new Error("Errore nella richiesta");
      else {
        if (response.data && response.data && response.data.Result === 0)
          return response.data;
        else {
          if (response.data && response.data.ResultMessage)
            throw new Error(response.data.ResultMessage);
          else throw new Error("Errore nella richiesta");
        }
      }
    } catch (err) {
      throw err;
    }
  }

  async ecubeEdiSaveJob(
    tokenApi: string,
    pluginObject: {
      JobID: string;
      JobDescription: string;
      Params: string; // Dipende dal sorgente dati
      Input: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Output: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Transcode?: DataExchangeJobsTranscode[];
    }
  ): Promise<{
    Result: number;
    MessageResult: string;
  }> {
    let url = `${this.apiUrl}api/DataExchange/Job`;

    try {
      let response = await axios.post(url, pluginObject, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (response.status !== 200) throw new Error("Errore nella richiesta");

      if (response.data && response.data.length > 0) {
        return response.data[0];
      } else {
        return {
          Result: 0,
          MessageResult: "OK",
        };
      }
    } catch (err) {
      throw err;
    }
  }

  async ecubeEdiPreviewJob(
    params: {
      JobID: string;
      Params: string; // Dipende dal sorgente dati
      Input: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Content: string[]; // sarà sempre vuoto
    },
    tokenApi: string,
    isCheckedNumber: number
  ): Promise<{
    SessionId: string;
    ResourcesViews: {
      ResourcesViewsFields: ResourceField[];
      Results: {
        TotalRowCount: number;
        NumberOfPages: number;
        objectList: Array<any> | null;
      };
    };
  }> {
    let url = `${this.apiUrl}api/DataExchange/Preview`;
    if (isCheckedNumber === 0) {
      url += `?filter=flg_exportEDI=${isCheckedNumber}`;
    }

    const { data } = await axios.post(url, params, {
      headers: {
        Authorization: `Bearer ${tokenApi}`,
      },
    });

    return data;
  }

  async ecubeEdiFetchResourcesViewsFields(
    params: {
      JobID: string;
      Params: string; // Dipende dal sorgente dati
      Input: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Content: string[]; // sarà sempre vuoto
    },
    tokenApi: string
  ): Promise<{
    SessionId: string;
    ResourcesViews: {
      ResourcesViewsFields: ResourceField[];
      Results: {
        TotalRowCount: number;
        NumberOfPages: number;
        objectList: Array<any> | null;
      };
    };
  }> {
    const url = `${this.apiUrl}api/DataExchange/Preview?filter=1=0`;
    const response = await axios.post(url, params, {
      headers: {
        Authorization: `Bearer ${tokenApi}`,
      },
    });

    return response.data;
  }

  async ecubeEdiPreviewJobWithoutFilter(
    params: {
      JobID: string;
      Params: string; // Dipende dal sorgente dati
      Input: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Content: string[]; // sarà sempre vuoto
    },
    tokenApi: string
  ): Promise<
    [
      {
        ResourcesViewsFields: ResourceField[];
        Results: {
          TotalRowCount: number;
          NumberOfPages: number;
          objectList: Array<any> | null;
        };
      }
    ]
  > {
    let url = `${this.apiUrl}api/DataExchange/Preview`;

    try {
      const response = await axios.post(url, params, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (response.status !== 200) throw new Error("Errore nella richiesta");
      else {
        return response.data;
      }
    } catch (err) {
      throw err;
    }
  }

  // Chiamata API per Preview con filtri aggiunti
  async ecubeEdiPreviewFilters(
    params: {
      JobID: string;
      Params: string; // Dipende dal sorgente dati
      Input: {
        Device_ID: string; // UUID
        Plugin_ID: string; // UUID
      };
      Content: string[]; // sarà sempre vuoto
    },
    tokenApi: string,
    filters: string
  ): Promise<{
    SessionId: string;
    ResourcesViews: {
      ResourcesViewsFields: ResourceField[];
      Results: {
        TotalRowCount: number;
        NumberOfPages: number;
        objectList: Array<any> | null;
      };
    };
  }> {
    const url = `${this.apiUrl}api/DataExchange/Preview?filter=${filters}`;

    const response = await axios.post(url, params, {
      headers: {
        Authorization: `Bearer ${tokenApi}`,
      },
    });

    return response.data;
  }

  executeJob = async (
    jobId: string,
    tokenApi: string,
    flagCondition: string | undefined,
    selected_items?: any[]
  ): Promise<{ SessionId: string }> => {
    const url =
      this.apiUrl + `api/DataExchange?job_id=${jobId}${flagCondition}`;

    const response = await axios.post(url, selected_items, {
      headers: {
        Authorization: `Bearer ${tokenApi}`,
      },
    });

    return response.data;
  };

  // Chiamata Api di esecuzione con i filtri aggiunti
  executeJobWithFilters = async (
    jobId: string,
    tokenApi: string,
    filters: string,
    selected_items?: any[]
  ): Promise<{
    SessionId: string;
  }> => {
    const url =
      this.apiUrl + `api/DataExchange?filter=${filters}&job_id=${jobId}`;

    const { data } = await axios.post(url, selected_items, {
      headers: {
        Authorization: `Bearer ${tokenApi}`,
      },
    });

    return data;
  };

  // Chiamata Api per recuperare i logs di un job quando va in errore l'esecuzione
  getJobLogs = async (
    sessionId: string,
    tokenApi: string
  ): Promise<DataExchangeJobLogs[]> => {
    let url =
      this.apiUrl +
      `api/Resources/DataExchangeJobsLogs/query?RecordSelection=session='${sessionId}' AND (LogSeverity=0 OR LogSeverity=10 OR LogSeverity=20)`;

    try {
      const response = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
        }
      );

      if (response.status !== 200) {
        throw new Error("Errore nella richiesta");
      } else {
        if (
          response.data &&
          response.data.length > 0 &&
          response.data[0].Results
        ) {
          return response.data[0].Results.objectList;
        } else {
          return [];
        }
      }
    } catch (err) {
      throw err;
    }
  };

  // VALIDATION
  async validateObject(
    endpoint: string,
    object: any,
    tokenApi: string
  ): Promise<{
    HasErrors: boolean;
    FullErrrorMessage: string;
    ResultsSet: ResultsSet[];
  }> {
    let url = this.apiUrl;
    if (url.slice(-1) == "/") url = url.slice(0, -1);

    let urlToUse = `${url}`;

    // se l'endpoint non inizia con / lo aggiungo
    if (endpoint.slice(0, 1) !== "/") urlToUse += "/";
    urlToUse += `${endpoint}/validate`;

    try {
      // Per ogni chiave all'interno dell'oggetto, se il valore è un [] lo rimuovo
      for (const key in object) {
        if (Array.isArray(object[key])) delete object[key];
      }

      const { data } = await axios.post(urlToUse, [object], {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      // Result

      /*
				ErrorLevel: 
					- 0 -> Messaggio informativo colore blu
					- 1 -> Warning colore giallo
					- 2 -> Errore colore rosso
			*/

      // ErrorMessage -> Probabilmente non mi servirà mai
      // FullErrrorMessage -> Probabilmente non mi servirà mai

      // Result di tutti gli oggetti passati
      // MessageResult -> Probabilmente non mi servirà mai
      // ValidationResultsSet -> Errori per ogni oggetto passato

      if (
        data &&
        data.length > 0 &&
        data[0].ValidationResultsSet // Esso contiene per ogni oggetto che passo la lista degli errori
      ) {
        // Dato corretto
        return data[0].ValidationResultsSet;
      } else {
        throw new Error("Errore nella validazione dell'oggetto");
      }
    } catch (err) {
      if (err && isAxiosError(err)) {
        if (err.response?.status === 422) {
          let data = err.response?.data;
          if (data && data.length > 0 && data[0].ValidationResultsSet) {
            return data[0].ValidationResultsSet;
          }
        }
      }

      throw err;
    }
  }

  // Fa sempre una post all'url con l'aggiunta di /query. Opzionalmente passa la vista di filtraggio
  async getItems(
    resourceURL: string,
    tokenAPI: string,
    resourceViewBody?: string,
    returnFields?: boolean
  ) {
    if (!resourceViewBody || resourceViewBody == "") resourceViewBody = "[]";
    var urlToUse = resourceURL.includes("RecordSelection")
      ? this.apiUrl +
        resourceURL.replace("?RecordSelection", "/query?RecordSelection")
      : resourceURL.includes("query")
      ? this.apiUrl + resourceURL
      : this.apiUrl + resourceURL + "/query";
    try {
      /*const { data } = await axios.post(urlToUse, resourceViewBody, {
        headers: {
          "Authorization": `Bearer ${tokenAPI}`,
          "Content-Type": "application/json",
        },
      });*/

      const response = await fetch(urlToUse, {
        method: "POST",
        headers: {
          Authorization: "bearer " + tokenAPI,
          "Content-Type": "application/json",
        },
        body: resourceViewBody,
      });

      try {
        const data = await response.json();

        if (response.ok) {
          if (returnFields !== undefined && returnFields === true) {
            //Se l'utente quando fa la chiamata vuole recuperare anche i Fields, allora restituisco tutto data.
            /*
                            
                        */
            return data;
          } else {
            var dataToRet = data[0];
            if (dataToRet.Results) {
              dataToRet = data[0].Results;
              if (dataToRet.objectList) {
                return dataToRet.objectList;
              }
              //else return dataToRet
              else return [];
            } else return dataToRet;
          }
        }

        // Se response non è ok mando un alert con cosa è andato storto
        else {
          //alert(resourceURL + ' ' + data[0].MessageResult)

          if (data.Message) {
            notify(data.Message, "error", 2000);
            throw data.Message;
          } else {
            throw data[0].MessageResult;
          }
        }
      } catch (errResponseJSON) {
        //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
        if (!response.ok) {
          //alert('Errore nel JSON Response alla chiamata: ' + resourceURL + '. ' + errResponseJSON)
          throw errResponseJSON;
        }
      }
    } catch (errFetch) {
      if (errFetch && String(errFetch) > "") notify(errFetch, "error", 2000);
      else {
        notify(
          "Errore nel fetch alla chiamata: " + resourceURL + ". " + errFetch,
          "error",
          2000
        );
      }

      throw errFetch;
    }
  }

  getAttachments = async (
    resourceId: number,
    itemId: number | string,
    tokenApi: string
  ): Promise<ResourceAttachment[]> => {
    let url = `${this.apiUrl}api/sys/ResourcesAttachments/query?RecordSelection=Resource_ID=${resourceId} and Item_ID=${itemId}`;

    try {
      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (data && data.length > 0 && data[0].Results) {
        return data[0].Results.objectList;
      }

      return [];
    } catch (error) {
      throw error;
    }
  };

  getFilterListOnly = async (
    resourceName: string,
    tokenAPI: string,
    MenuItem_ID: number
  ): Promise<FilterList[]> => {
    //https://deploy.e-cube.it/api/Resources/ProdVersamentoTempi/query?filterlistonly=1
    let url =
      this.apiUrl + "api/Resources/" + resourceName + "/query?filterlistonly=1";

    try {
      let body = [
        {
          ApplyCustomFilter: false,
          MenuItem_ID: MenuItem_ID,
        },
      ];

      const response = await axios.post(url, JSON.stringify(body), {
        headers: {
          Authorization: `Bearer ${tokenAPI}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data) {
        return response.data;
      } else {
        throw new Error("Errore nella richiesta");
      }
    } catch (error) {
      throw error;
    }
  };

  getMenuItemsGridCustomActions = async (
    MenuItem_ID: number,
    tokenApi: string
  ): Promise<MenuItemGridCustomAction[]> => {
    let url = `${this.apiUrl}api/sys/${ResourceNames.MenuItemsGridCustomActions}/query?RecordSelection=MenuItem_ID=${MenuItem_ID}`;

    try {
      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
        }
      );

      if (
        data &&
        data.length > 0 &&
        data[0].Results &&
        data[0].Results.objectList
      ) {
        return data[0].Results.objectList;
      }

      return [];
    } catch (error) {
      throw error;
    }
  };

  getUserCompany = async (
    userId: string,
    customer_ID: number,
    tokenApi: string
  ): Promise<UserCompany> => {
    let url = `${this.apiUrl}api/sys/${ResourceNames.UserCompanies}/query?RecordSelection=UserId='${userId}' and customer_ID=${customer_ID}`;

    try {
      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
        }
      );

      if (
        data &&
        data.length > 0 &&
        data[0].Results &&
        data[0].Results.objectList &&
        data[0].Results.objectList.length > 0
      ) {
        return data[0].Results.objectList[0];
      } else {
        throw new Error("Errore nella richiesta");
      }
    } catch (error) {
      throw error;
    }
  };

  getUserCompanies = async (tokenApi: string): Promise<UserCompany[]> => {
    let url = `${this.apiUrl}api/sys/${ResourceNames.UserCompanies}/query`;

    try {
      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
        }
      );

      if (
        data &&
        data.length > 0 &&
        data[0].Results &&
        data[0].Results.objectList
      ) {
        return data[0].Results.objectList;
      }

      return [];
    } catch (error) {
      throw error;
    }
  };

  getUserProducts = async (tokenApi: string): Promise<UserProduct[]> => {
    let url = `${this.apiUrl}api/sys/${ResourceNames.UserProducts}/query`;

    try {
      const { data } = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
        }
      );

      if (
        data &&
        data.length > 0 &&
        data[0].Results &&
        data[0].Results.objectList
      ) {
        return data[0].Results.objectList;
      }

      return [];
    } catch (error) {
      throw error;
    }
  };

  getWebSocketClients = async (
    tokenApi: string
  ): Promise<WebSocketClient[]> => {
    let url = `${this.apiUrl}api/sys/${ResourceNames.WebSocketClients}`;

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${tokenApi}`,
        },
      });

      if (data) {
        return data;
      }

      return [];
    } catch (error) {
      throw error;
    }
  };

  deleteObject = async (
    objToDel: any,
    objUrl: string,
    tokenAPI: string
  ): Promise<any> => {
    try {
      const { data } = await axios.delete(this.apiUrl + objUrl, {
        headers: {
          Authorization: `Bearer ${tokenAPI}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: [objToDel],
      });

      return data;
    } catch (error) {
      throw error;
    }
  };

  // async deleteObject(objToDel: any, objUrl: string, tokenAPI: string) {
  //   try {
  //     const response = await fetch(this.apiUrl + objUrl, {
  //       method: "DELETE",
  //       headers: {
  //         Authorization: "bearer " + tokenAPI,
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(objToDel),
  //     });
  //     try {
  //       const data = await response.json();

  //       if (response.ok) return data;
  //       // Se response non è ok mando un alert con cosa è andato storto
  //       else {
  //         //alert(objUrl + ' ' + data.ExceptionMessage)

  //         if (data.length > 0 && data[0].MessageResult) {
  //           throw data[0].MessageResult;
  //         } else if (data.ExceptionMessage) {
  //           throw data.ExceptionMessage;
  //         }
  //       }
  //     } catch (errResponseJSON) {
  //       //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
  //       if (!response.ok) {
  //         //alert('Errore nel JSON Response alla chiamata: ' + objUrl + '. ' + errResponseJSON)
  //         throw errResponseJSON;
  //       }
  //     }
  //   } catch (errFetch) {
  //     if (errFetch && String(errFetch) > "") notify(errFetch, "error", 2000);
  //     else {
  //       notify(
  //         "Errore nel fetch alla chiamata: " + objUrl + ". " + errFetch,
  //         "error",
  //         2000
  //       );
  //     }
  //     throw errFetch;
  //   }
  // }

  async updateObject(myObject: any, myResUrl: string, tokenAPI: string) {
    try {
      const arrP = [myObject];

      const response = await fetch(this.apiUrl + myResUrl, {
        method: "POST",
        headers: {
          Authorization: "bearer " + tokenAPI,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(arrP),
      });
      try {
        const data = await response.json();

        if (response.ok) return data;
        // Se response non è ok mando un alert con cosa è andato storto
        else {
          //alert(myResUrl + ' ' + data[0].MessageResult)
          if (data.ExceptionMessage) {
            notify(data.ExceptionMessage, "error", 2000);
            throw data.ExceptionMessage;
          } else {
            throw data[0].MessageResult;
          }
        }
      } catch (errResponseJSON) {
        //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
        if (!response.ok) {
          //alert('Errore nel JSON Response alla chiamata: ' + myResUrl + '. ' + errResponseJSON)
          throw errResponseJSON;
        }
      }
    } catch (errFetch) {
      if (errFetch && String(errFetch) > "") notify(errFetch, "error", 2000);
      else {
        notify(
          "Errore nel fetch alla chiamata: " + myResUrl + ". " + errFetch,
          "error",
          2000
        );
      }
      throw errFetch;
    }
  }

  async updateObjects(myObjects: any[], myResUrl: string, tokenAPI: string) {
    try {
      const arrP = myObjects;
      const bodyToSend = JSON.stringify(arrP);

      const response = await fetch(this.apiUrl + myResUrl, {
        method: "POST",
        headers: {
          Authorization: "bearer " + tokenAPI,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: bodyToSend,
      });
      try {
        const data = await response.json();

        if (response.ok) return data;
        // Se response non è ok mando un alert con cosa è andato storto
        else {
          //alert(myResUrl + ' ' + data.ExceptionMessage)
          throw data[0].MessageResult;
        }
      } catch (errResponseJSON) {
        //Al momento essendo che non mi dà un JSON in risposta andiamo sempre qui
        if (!response.ok) {
          //alert('Errore nel JSON Response alla chiamata: ' + myResUrl + '. ' + errResponseJSON)
          throw errResponseJSON;
        }
      }
    } catch (errFetch) {
      if (errFetch && String(errFetch) > "") notify(errFetch, "error", 2000);
      else {
        notify(
          "Errore nel fetch alla chiamata: " + myResUrl + ". " + errFetch,
          "error",
          2000
        );
      }
      throw errFetch;
    }
  }
}
